var _rect, _path, _rect2, _circle, _circle2, _path2, _path3, _rect3, _circle3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBabyBili(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 51,
    viewBox: "0 0 58 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 11.5,
    width: 47,
    height: 39,
    rx: 11.5,
    fill: "#F4F0E5",
    stroke: "#003738"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1925 44.0072C27.8722 44.1723 29 46.1237 29 47.9997C29 46.1237 29.8649 44.334 31.9184 44.0071C32.401 46.7113 30.528 47.9979 29 47.9997C27.472 48.0015 25.3481 46.2494 26.1925 44.0072Z",
    fill: "#4B6B4B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 19.5,
    width: 35,
    height: 23,
    rx: 7.5,
    fill: "#FFEEDB",
    stroke: "#4B6B4B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 28,
    r: 4,
    fill: "#4B6B4B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 28,
    r: 4,
    fill: "#4B6B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5428 35.104C30.7281 36.4597 27.2725 36.4597 24.4579 35.104C23.9659 34.867 23.364 35.0488 23.111 35.5097C22.8581 35.9707 23.052 36.5347 23.544 36.7717C25.2128 37.5746 27.0995 38 29.0003 38C30.9011 38 32.7879 37.5756 34.4567 36.7717C34.9476 36.5347 35.1416 35.9707 34.8896 35.5097C34.6376 35.0488 34.0347 34.867 33.5428 35.104Z",
    fill: "#4B6B4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 47L29 47.5L30 47L29.5 47.5V49H28.5V47.5L28 47Z",
    fill: "#4B6B4B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 7,
    width: 2,
    height: 5,
    fill: "#003738"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 4,
    r: 4,
    fill: "#003738"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 23C52 22.7308 52.23 22.5192 52.4983 22.5415L55.2491 22.7708C56.804 22.9003 58 24.2001 58 25.7604V36.2396C58 37.7999 56.804 39.0997 55.2491 39.2292L52.4983 39.4585C52.23 39.4808 52 39.2692 52 39V31V23Z",
    fill: "#003738"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.7604C0 24.2001 1.19599 22.9003 2.75086 22.7708L5.50173 22.5415C5.76995 22.5192 6 22.7308 6 23V39C6 39.2692 5.76995 39.4808 5.50173 39.4585L2.75086 39.2292C1.19599 39.0997 0 37.7999 0 36.2396V31V25.7604Z",
    fill: "#003738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabyBili);
export default __webpack_public_path__ + "static/media/babyBili.b3e78e16f75fca83da88380e7c913a57.svg";
export { ForwardRef as ReactComponent };